export enum INCOMPLETE_TYRES_STORAGE_KEYS {
  PageSizePreference = "incomplete-tyres-page-size-preference"
}
